export function toHttpPararms(model: any): { [key: string]: string | string[] } {
    const params: { [key: string]: string | string[] } = {};
    if (!model) {
        return params;
    }


    for (const key in model) {
        const val = model[key];
        if (val === undefined || val === null || val === '') continue;
        if (Array.isArray(val)) {
            if (val.length === 0) continue;
            params[key] = val.map(v => `${v}`);
        }
        else if (val instanceof Date) {
            params[key] = val.toISOString();
        }
        else {
            params[key] = `${val}`;
        }
    }
    return params;

}
